import api from '../utils/httpClient';
import { createSlice } from '@reduxjs/toolkit';
//import { createAsyncThunk } from '@reduxjs/toolkit';

interface ExternalAppUsage {
  accountId?: string
  patientId: string
  appId: string
}


export const trackAppStarted = (appData: ExternalAppUsage) : Promise<any> => {
  console.log('trackAppStarted params', appData);
  return api.post(
    `/external_app/track_start`,
    appData
  )
  .then((response)=>{
    console.log("trackAppStarted response", response.data);
  })
  .catch((e:any) => console.warn("Error on trackAppStarted: ", e));;
}

export const trackAppStopped = (appData: ExternalAppUsage) : Promise<any> => {
  console.log('trackAppStopped params', appData);
  return api.post(
    `/external_app/track_stop`,
    appData
  )
  .then((response)=>{
    console.log("trackAppStopped response", response.data);
  })
  .catch((e:any) => console.warn("Error on trackAppStopped: ", e));;
}



const initialState: {
  loading: boolean;
  complete: boolean;
  error: string;
} = {
  loading: false,
  complete:false,
  error: '',
};

const externalAppSlice:any = createSlice({
  name: 'externalApp',
  initialState: initialState,
  reducers: {

  },
  // extraReducers: (builder:any) => {


  // }
});

export const { externalAppSliceClean } = externalAppSlice.actions;
export default externalAppSlice;
